<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding hezuo_section1" style="height:800px;">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">合作伙伴</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style="animation-duration: 1s; animation-delay: 1s; visibility: visible; color: #E91E63;">{{hbname}}</p>
      </div>
    </section>
    <!-- Map Area End -->
    <!-- 合作伙伴 starts -->

    <section class="section-padding8">
      <div class="container">
        <div class="donghuasun hezuokuandu"
          style="width: 100%;height: 200px;border-bottom: 1px solid #ccc; text-align: center;animation-duration: 1s; animation-delay: 0.3s;">
          <p> <br><br><br></p>
          <p style="font-size: 20px; font-weight: 600; color: #666666;">战略合作伙伴 · <span style="color: #44BCB9;">{{
            newsinfo.title }}</span></p>
          <p style="float: left;">• {{ newsinfo.date }}</p>
          <p style="float: right;">浏览量：{{ newsinfo.visits }}</p>
        </div>
        <div style="margin-bottom: auto;margin-top:40px;line-height:40px; display: flex;">
          <p v-html="newsinfo.content" style="width: 100%;"></p>
          <p> <br></p>

        </div>
      </div>

    </section>

    <!-- 合作伙伴 end -->




  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      huobanlist: [
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
        {
          ico: '',
          id: '',
          title: ''
        },
      ],
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      thisid: '',
      newsinfo: [],
      hbname:'CONTACTS',
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {

    // 获取当前id
    this.thisid = this.$route.query.id;
    if(this.$route.query.name){
      this.hbname = this.$route.query.name;
    }

    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //导航数据
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.daohanglist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //详情
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.newsinfo = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //战略合作伙伴
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/29/num/20/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.huobanlist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    //提交留言
    buttonmess() {
      // Message.success(`输入的内容是: ${this.messtitle}`);
      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        // console.log('可以继续进行');
        // console.log('输入的内容是:', this.messname);
        // console.log('输入的内容是:', this.messtel);
        // console.log('输入的内容是:', this.messtitle);
        axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        })
          .then(response => {
            // console.log(response.data.data);
            // that.bannerlist = response.data.data;
            alert('留言提交成功!');
            this.messname = '';
            this.messtel = '';
            this.messtitle = '';
          })
          .catch(error => {
            console.error('当前网络环境异常!', error);
          });

      } else {
        alert('内容不能为空');
        return;
        // console.log('不能为空');
      }

    }
  }
};

</script>




// WEBPACK FOOTER //
// huoban.vue?22eb8591